import {MenuComponent} from '../assets/js/components'


const reInitMenu = () => {
    setTimeout(() => {
        MenuComponent.reinitialization()
    }, 500)
}

export {reInitMenu}
